'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'face-sleeping';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e38d';
var svgPathData = 'M528-48c0 8.8 7.2 16 16 16l45.8 0-58.1 69.8c-4 4.8-4.8 11.4-2.2 17S537.8 64 544 64l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-45.8 0 58.1-69.8c4-4.8 4.8-11.4 2.2-17S630.2-64 624-64l-80 0c-8.8 0-16 7.2-16 16zM368 48c0 8.8 7.2 16 16 16l45.8 0-58.1 69.8c-4 4.8-4.8 11.4-2.2 17s8.3 9.2 14.5 9.2l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-45.8 0 58.1-69.8c4-4.8 4.8-11.4 2.2-17S470.2 32 464 32l-80 0c-8.8 0-16 7.2-16 16zM320 0C178.6 0 64 114.6 64 256S178.6 512 320 512 576 397.4 576 256c0-16.4-1.5-32.5-4.5-48l-32.7 0c3.4 15.5 5.2 31.5 5.2 48 0 123.7-100.3 224-224 224S96 379.7 96 256 196.3 32 320 32l0-32zm0 408a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-56-24a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zM408 272c-13.3 0-24-10.7-24-24 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 30.9 25.1 56 56 56l16 0c30.9 0 56-25.1 56-56 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 13.3-10.7 24-24 24l-16 0zM192 248c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 30.9 25.1 56 56 56l16 0c30.9 0 56-25.1 56-56 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceSleeping = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;